exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".checkbox[data-v-64925558],input[data-v-64925558],textarea[data-v-64925558]{margin-bottom:0}.invalid-feedback[data-v-64925558]{height:20px;padding:0 0 0 1rem;margin:10px 0;display:block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-64925558","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/ContactForm.vue
// module id = 6LNQ
// module chunks = 3